import { render, staticRenderFns } from "./ServicesPakageDialog.vue?vue&type=template&id=b61b193c&scoped=true"
import script from "./ServicesPakageDialog.vue?vue&type=script&lang=js"
export * from "./ServicesPakageDialog.vue?vue&type=script&lang=js"
import style0 from "./ServicesPakageDialog.vue?vue&type=style&index=0&id=b61b193c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61b193c",
  null
  
)

export default component.exports